import { useState, useEffect } from 'react';

export function useWindowSize({
  customBreakpoints = {},
} = {}) {
  const defaultBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  };

  const breakPoints = { ...defaultBreakpoints, ...customBreakpoints };

  const [breakpoint, setBreakpoint] = useState("md");
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setWindowSize({ width, height });

      switch (true) {
        case width >= breakPoints.xxl:
          setBreakpoint("xxl");
          break;
        case width >= breakPoints.xl:
          setBreakpoint("xl");
          break;
        case width >= breakPoints.lg:
          setBreakpoint("lg");
          break;
        case width >= breakPoints.md:
          setBreakpoint("md");
          break;
        case width >= breakPoints.sm:
          setBreakpoint("sm");
          break;
        default:
          setBreakpoint("xs");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    width: windowSize.width,
    height: windowSize.height,
    breakpoint,
  };
}
